module.exports = __webpack_public_path__ + "img/b-cicle-inner.66ac88c8.png";